import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { selectedStudentIdAtom, useStudentListState } from '@atoms/states';
import { useRouter } from 'next/router';
import { useRecoilState } from 'recoil';
import * as amplitude from '@amplitude/analytics-browser';
import { useEventPropertiesStore } from '@store/common';
import * as S from '@styles/common/nav/Gnb.style';
import { useTranslation } from 'next-i18next';
import { StudentPage, TeacherPage } from '@asset/enum/page';
import { useSelectedStudentInfoQuery, useUserInfoQuery } from '@apis/query/user';
import { STUDENT_STUDY_CONTENT_URL_PREFIX } from 'routes/studyContent';
import _ from 'lodash';
import SelectStudentDropdown from '../dropDown/SelectStudentDropDown';
import { MANAGE_COURSE_DETAIL_URL_PREFIX } from 'routes/manageCourse';
import { logoutAndResetUserInfo } from '@asset/function/auth';
import { TeacherPosition, UserType } from '@asset/enum/UserEnum';
import { useQuery } from 'react-query';
import UserAvatarProfile from '../UserAvatarProfile';
import GnbChatButton from '@components/chat/GnbChatButton';
import { useUserStore } from '@store/user';
import { getTeacherApi } from '@apis/api/teacher/common';
import AlmightyCampusIcon from '@asset/svg/AlmightyCampusIcon';
import { Button } from '@components/amc/Button';
import { getStudyManagementPageUrlObject, MANAGE_SCHOOL_URL_PREFIX, MY_STUDY_CLASS_URL_PREFIX } from 'routes/common';
import QueryString from 'qs';
import { getManageTotalStudyStatusListPageUrlObject } from 'routes/manageDashboard';
import { MANAGE_STORAGE_URL_PREFIX, SIMILAR_STUDY_ITEM_URL_PREFIX } from 'routes/manageStudyContent';
import { IconBook, IconBriefcase, IconCalendarEvent, IconClipboardData, IconHome, IconLibrary, IconSchool, IconLogout, IconTrophy, IconCaretDownFilled } from '@tabler/icons-react';
import DropdownActionMenu from '@components/common/DropdownActionMenu';
import { useStudentsExtrasQuery } from '@apis/query/student';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const Gnb = ({
  isVisibleChatButton
}) => {
  const router = useRouter();
  const {
    t,
    ready
  } = useTranslation('gnb');
  const {
    logOut
  } = useUserStore();
  const [selectedStudentId, setSelectedStudentId] = useRecoilState(selectedStudentIdAtom);
  const [studentList, setStudentList] = useStudentListState();
  const {
    data: user
  } = useUserInfoQuery();
  const {
    data: selectedStudent
  } = useSelectedStudentInfoQuery();
  const {
    properties
  } = useEventPropertiesStore();
  const [currentUrlPath, setCurrentUrlPath] = useState(null);
  const studyManagementPageUrlInfo = user?.type === UserType.TEACHER ? getStudyManagementPageUrlObject({
    teacherIds: [user?.id]
  }) : null;
  const teacherMenuItems = [{
    url: `/manage/${TeacherPage.CLASS}/main/`,
    title: 'gnb:teacher.manageStudent',
    urlKeyword: ['manage/dashboard', `manage/student-study-content`, `manage/student`, getManageTotalStudyStatusListPageUrlObject().pathname, `manage/checking`, `manage/${TeacherPage.CLASS}`, MY_STUDY_CLASS_URL_PREFIX, 'manage/study-status-list'],
    pageType: 'manage_student',
    icon: /*#__PURE__*/_jsx(IconSchool, {
      size: 16
    })
  }, {
    url: '/manage/material-list/?isHidden=false',
    title: 'gnb:teacher.manageTextbook',
    urlKeyword: ['/manage/material', '/manage/course', SIMILAR_STUDY_ITEM_URL_PREFIX, MANAGE_STORAGE_URL_PREFIX],
    pageType: 'manage_study_material',
    icon: /*#__PURE__*/_jsx(IconLibrary, {
      size: 16
    })
  }, {
    url: studyManagementPageUrlInfo?.pathname + '?' + QueryString.stringify(studyManagementPageUrlInfo?.query),
    title: 'gnb:teacher.management',
    urlKeyword: ['manage/teacher', getStudyManagementPageUrlObject().pathname, MANAGE_SCHOOL_URL_PREFIX],
    pageType: 'manage_teacher',
    icon: /*#__PURE__*/_jsx(IconBriefcase, {
      size: 16
    })
  }];
  const studentMenuItems = [{
    url: '/dashboard',
    title: 'gnb:student.home',
    urlKeyword: [],
    pageType: 'main_dashboard',
    icon: /*#__PURE__*/_jsx(IconHome, {
      size: 16
    })
  }, {
    url: `/dashboard/study/${StudentPage.MY_ASSIGNMENTS}`,
    title: 'gnb:student.learn',
    urlKeyword: [StudentPage.MY_ASSIGNMENTS, StudentPage.MY_TESTS, StudentPage.MY_STUDY_MATERIALS, StudentPage.MY_FEEDBACKS, StudentPage.MY_QUESTIONS, StudentPage.MY_ASSIGNED_STUDY_MATERIAL],
    pageType: 'my_assignments',
    icon: /*#__PURE__*/_jsx(IconBook, {
      size: 16
    })
  }, {
    url: `/dashboard/plan/${StudentPage.MY_SCHEDULE}`,
    title: 'gnb:student.plan',
    urlKeyword: [StudentPage.MY_PLANS, StudentPage.MY_SCHEDULE],
    pageType: 'my_plans',
    icon: /*#__PURE__*/_jsx(IconCalendarEvent, {
      size: 16
    })
  }, {
    url: `/dashboard/analysis/${StudentPage.MY_STUDY_RECORDS}`,
    title: 'gnb:student.analytics',
    urlKeyword: [StudentPage.MY_STUDY_RECORDS, StudentPage.LEVEL_TEST],
    pageType: 'my_study_records',
    icon: /*#__PURE__*/_jsx(IconClipboardData, {
      size: 16
    })
  }, {
    url: `/dashboard/${StudentPage.MY_RANKING}`,
    title: 'gnb:student.ranking',
    urlKeyword: [StudentPage.MY_RANKING],
    pageType: 'ranking',
    icon: /*#__PURE__*/_jsx(IconTrophy, {
      size: 16
    })
  }];
  const menuItemList = user?.type === UserType.TEACHER ? teacherMenuItems : user?.type === UserType.STUDENT ? studentMenuItems : [];
  const isPickedUrl = element => {
    if (element.url === currentUrlPath) return true;else {
      for (let index = 0; index < element?.urlKeyword?.length; index++) {
        if (currentUrlPath?.includes(element?.urlKeyword[index])) return true;
      }
    }
    return false;
  };
  const {
    data: teacherInfo
  } = useQuery(['GET_TEACHER_INFORMATION', user], async () => (await getTeacherApi(user.id)).data, {
    enabled: !_.isNil(user) && user?.type === UserType.TEACHER
  });
  useEffect(function () {
    if (router.isReady) {
      setCurrentUrlPath(router.asPath);
      if (user?.type === UserType.TEACHER) {
        if (router.pathname.startsWith('/manage/dashboard/')) {
          const studentId = router.asPath.split('/')[4] ? parseInt(router.asPath.split('/')[4]) : router.query.type ? parseInt(router.query.type[1]) : selectedStudentId ? selectedStudentId : null;
          if (!_.isNaN(studentId) && !_.isNil(studentId)) {
            if (selectedStudentId !== studentId) setSelectedStudentId(studentId);
          } else {
            router.replace('/');
          }
        } else if (router.pathname.startsWith(STUDENT_STUDY_CONTENT_URL_PREFIX) || router.pathname.startsWith(MANAGE_COURSE_DETAIL_URL_PREFIX)) {
          const studentId = router.query.studentId ? parseInt(router.query.studentId) : null;
          if ((!selectedStudent || selectedStudent?.id !== studentId) && studentId) setSelectedStudentId(studentId);
        }
      }
    }
  }, [router, user]);
  const {
    data: studentExtrasRaw
  } = useStudentsExtrasQuery(user?.type === UserType.STUDENT ? [user?.id] : []);
  const studentExtras = studentExtrasRaw?.data[0];
  const handleLogout = async () => {
    await logoutAndResetUserInfo(user?.userId);
    logOut();
    setSelectedStudentId(null);
    setStudentList(null);
  };
  return /*#__PURE__*/_jsxs(S.GnbLayout, {
    display: user?.type === UserType.TEACHER ? 'flex' : 'grid',
    children: [/*#__PURE__*/_jsx(S.GnbMainLogoWrapper, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "object-container",
        children: [/*#__PURE__*/_jsx(Link, {
          href: '/'
        }), /*#__PURE__*/_jsx("object", {
          data: "/common/logo/gnb_white_logo.svg",
          type: 'image/svg+xml'
        })]
      })
    }), /*#__PURE__*/_jsx(S.GnbMenuItemContainer, {
      justifyContent: user?.type === UserType.STUDENT ? 'center' : 'start',
      gap: user?.type === UserType.STUDENT ? '1rem' : '1.5rem',
      children: menuItemList.map(element => {
        return ready ? /*#__PURE__*/_jsxs(Link, {
          href: element.url,
          onClick: () => {
            const logText = `click_main_nav_${element?.pageType}`;
            amplitude.track(logText, properties);
          },
          className: `${isPickedUrl(element) ? 'picked' : ''} ${['Leaderboard'].includes(t(element.title)) ? '!hidden' : ''}`,
          children: [element.icon, t(element.title)]
        }, element.url) : '';
      })
    }), /*#__PURE__*/_jsxs(S.GnbUserInfoSection, {
      children: [user?.type === UserType.TEACHER ? /*#__PURE__*/_jsx(SelectStudentDropdown, {}) : user?.type === UserType.PARENT && studentList ? /*#__PURE__*/_jsx(DropdownActionMenu, {
        trigger: /*#__PURE__*/_jsxs(S.StudentListDropDownContainer, {
          children: [/*#__PURE__*/_jsx("p", {
            children: selectedStudent?.name
          }), /*#__PURE__*/_jsx(IconCaretDownFilled, {
            size: 16,
            color: "hsl(var(--nav-accent-foreground))"
          })]
        }),
        items: studentList.map(obj => ({
          label: obj.name,
          selected: obj.id === selectedStudent?.id,
          onClick: async () => {
            setSelectedStudentId(Number(obj.id));
            router.query.studentId = obj.id;
            router.replace(router);
          }
        })),
        contentProps: {
          align: 'end',
          className: 'min-w-[8rem]'
        }
      }) : /*#__PURE__*/_jsx(_Fragment, {}), isVisibleChatButton && /*#__PURE__*/_jsx(GnbChatButton, {
        darkMode: true
      }), user && /*#__PURE__*/_jsx(GnbUserMenu, {
        user: user,
        studentInfo: studentExtras,
        teacherInfo: teacherInfo,
        handleLogout: handleLogout
      })]
    })]
  });
};
export default Gnb;
const GnbUserMenu = ({
  user,
  studentInfo,
  teacherInfo,
  handleLogout
}) => {
  const {
    t,
    ready
  } = useTranslation(['gnb']);
  const router = useRouter();
  if (!user) {
    return null;
  }
  switch (user.type) {
    case UserType.STUDENT:
      if (!studentInfo) {
        return null;
      }
      return /*#__PURE__*/_jsx(GnbAvatarButton, {
        userInfo: {
          userType: user.type,
          avatarName: studentInfo.avatarName || ''
        },
        menuList: [{
          text: ready ? t('gnb:myInfo.myInfo') : '',
          onClick: () => router.push(`/dashboard/my-page/${StudentPage.MY_INFORMATION}`)
        }, {
          text: ready ? t('gnb:myInfo.logOut') : '',
          onClick: handleLogout
        }]
      });
    case UserType.TEACHER:
      if (!teacherInfo) {
        return null;
      }
      return /*#__PURE__*/_jsx(GnbAvatarButton, {
        userInfo: {
          userType: user.type,
          teacherPosition: teacherInfo.position,
          avatarName: user.avatarName || ''
        },
        menuList: [{
          text: '마이 페이지',
          onClick: () => router.push(`/manage/teacher/update/${user.id}`)
        }, {
          text: ready ? t('gnb:myInfo.logOut') : '',
          onClick: handleLogout
        }]
      });
    default:
      return /*#__PURE__*/_jsx(Button, {
        variant: "Ghost",
        size: "Medium",
        className: "hover:!bg-zinc-700 active:!bg-zinc-700 [&_svg]:!stroke-[var(--gray-100)]",
        onClick: handleLogout,
        icon: /*#__PURE__*/_jsx(IconLogout, {
          color: "hsl(var(--nav-accent-foreground))"
        })
      });
  }
};
const GnbAvatarButton = ({
  userInfo,
  menuList
}) => {
  return /*#__PURE__*/_jsx(DropdownActionMenu, {
    trigger: isOpen => /*#__PURE__*/_jsx("div", {
      className: `relative w-6 h-6 rounded-[50%] box-content border-solid border-[2px] ${isOpen ? 'border-primary' : 'border-[transparent]'}`,
      children: userInfo.userType === UserType.TEACHER && userInfo.teacherPosition === TeacherPosition.TA ? /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center w-full h-full rounded-[50%] bg-background",
        children: /*#__PURE__*/_jsx(AlmightyCampusIcon, {
          width: 20,
          height: 20,
          color: "var(--blue-20)"
        })
      }) : /*#__PURE__*/_jsx(UserAvatarProfile, {
        name: userInfo.avatarName,
        className: "absolute"
      })
    }),
    items: menuList.map(item => ({
      label: item.text,
      onClick: item.onClick
    })),
    contentProps: {
      align: 'end'
    }
  });
};